import React, {useEffect, useState} from 'react';
import './golive.css'
import { registeredNumber, getRegisteredNumbers, initiateNumberPayment} from '../../apis/RegisterdNumbers'
import { useDispatch, useSelector } from 'react-redux';
import { Toaster, toast } from 'sonner'
import { Table, Spin, Tooltip }from "antd";
import { parsePhoneNumberFromString } from 'libphonenumber-js';

const Golive = () => {

  const dispatch = useDispatch()    
  const action = useSelector((state) => state.action)

  const [phoneNumber, setPhoneNumber] = useState()
  const [phoneNumberModal, setPhoneNumberModal] = useState(false)

  const [registeredNumbers, setRegisteredNumbers] = useState([])

  const [paymentDetails, setPaymentDetails] = useState({
    wabaNumber: "",
    customerPhone: "",
    customerEmail: ""
  })
  const [paymentModal, setPaymentModal] = useState(false)
  const [confirmOrder, setConfirmOrder] = useState(false)
  
  // Add new state for payment iframe
  // const [paymentIframeModal, setPaymentIframeModal] = useState(false)
  const [paymentUrl, setPaymentUrl] = useState("")

  const [formErrors, setFormErrors] = useState()

  const isPermittedTestNumber = (value) => {
    const digitsOnly = String(value ?? '').replace(/\D/g, '');
    if (!digitsOnly) {
      return false;
    }

    // Allow common US test numbers such as 1-555-XXXXXXX to pass validation.
    return digitsOnly.length === 11 && digitsOnly.startsWith('1') && digitsOnly.slice(1, 4) === '555';
  };


  useEffect(() => {
        getRegisteredNumbers(dispatch).then(resp => {
          if(resp.status === 200){
            setRegisteredNumbers(resp.data?.data)
          }
         })
    
      }, [dispatch])

  useEffect(() => {
  
    window.fbAsyncInit = function() {
      window.FB.init({
        appId            : '564683789153111',
        autoLogAppEvents : true,
        xfbml            : true,
        version          : 'v24.0'
      });
    };

    (function (d, s, id) {
    var js, fjs = d.getElementsByTagName(s)[0];
    if (d.getElementById(id)) return;
    js = d.createElement(s); js.id = id;
    js.src = "https://connect.facebook.net/en_US/sdk.js";
    fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));

  }, [dispatch])

 

  const validate = () => {
    const errors = {};
    if (!phoneNumber) {
      errors.phoneNumber = 'Phone number is required!';
    } else {
      const parsed = parsePhoneNumberFromString('+' + String(phoneNumber).trim());
      if ((!parsed || !parsed.isValid()) && !isPermittedTestNumber(phoneNumber)) {
        errors.phoneNumber = 'Enter a valid phone number with country code (e.g., 254712345678)';
      }
    }
    setFormErrors(errors);
    return errors;
  };



  const validatePaymentModal = () => {
    let errors = {};
  
    if (!paymentDetails.customerPhone) {
      errors['customerPhone'] = 'Phone number is required!';
    } else {
      const phoneNumber = parsePhoneNumberFromString('+' + paymentDetails.customerPhone);
      if ((!phoneNumber || !phoneNumber.isValid()) && !isPermittedTestNumber(paymentDetails.customerPhone)) {
        errors['customerPhone'] = 'Enter a valid phone number with country code (e.g., 254712345678)';
      }
    }
  
    if (!paymentDetails.customerEmail) {
      errors['customerEmail'] = 'Email is required!';
    } else {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(paymentDetails.customerEmail)) {
        errors['customerEmail'] = 'Enter a valid email address!';
      }
    }
  
    setFormErrors(errors);
    return errors;
  };

 // Facebook Login with JavaScript SDK
  const launchWhatsAppSignup = () => {
    if (Object.keys(validate()).length === 0) {

      window.FB.login((response) => {
        if (response.authResponse) {
          const accessToken = response.authResponse.accessToken
          console.log(accessToken)
          // Use this token to call the debug_token API and get the shared WABA's ID
          // You might want to call your API here
        } else {
          console.log('User cancelled login or did not fully authorize.')
        }
      }, {
        config_id: '814364934792855',
        response_type: 'code',
        override_default_response_type: true,
        extras: {
          featureType: "whatsapp_business_app_onboarding",
          sessionInfoVersion: "3",
          features: [
            {
              name: "marketing_messages_lite"
            }
          ],
          version: "v3"
        }
      })
    }

  }


  const handleRegisterNumber = () => {
    if (Object.keys(validate()).length === 0) {
      registeredNumber(dispatch, {phoneNumber: phoneNumber}).then(resp => {
              console.log(resp)
              if (resp?.status === 200) {
                if (resp?.data.error === true) {
                  toast.error(resp?.data.message, { theme: "colored" })
                } else {
                  handleCloseModal(dispatch)
                  launchWhatsAppSignup()
                }
              }
              else { toast.error("Error occurred!", { theme: "colored" }) }
            })
        }
  }


  const handleInitiateNumberPayment = () => {
    if (Object.keys(validatePaymentModal()).length === 0) {
      initiateNumberPayment(dispatch, paymentDetails).then(resp => {
              if (resp?.status === 200) {
                toast.success("Payment initiated successful", { theme: "colored" })
                if (resp?.data?.redirect_url) {
                  setPaymentUrl(resp.data.redirect_url)
                  setPaymentModal(false) 
                  setConfirmOrder(true)
                }
              }
              else { toast.error("Error occurred!", { theme: "colored" }) }
            })
        }
  }

  const handleConfirmOrder = () =>{   
      window.location.href = paymentUrl;
      
    }

const handleCloseModal = (dispatch) => {
  setPhoneNumber('')
  setPhoneNumberModal(false)
  setPaymentModal(false)
  // setPaymentIframeModal(false)
  setPaymentUrl("")
  document.getElementById("form-modal").reset();
  setFormErrors([])
  setPaymentDetails({
    wabaNumber: "",
    customerPhone: "",
    customerEmail: ""
  })
}

const loading = () =>{
  return <div class="lds-dual-ring"></div>
}


const statusColors = {
  ACTIVE: "#32CD32",
  PAUSED: "#FFBF00",
  PENDING_PAYMENT: "#1E90FF",
  REGISTERED: "#32CD32",
};

const registrationStatusDetails = {
  PENDING_REGISTRATION: {
    color: "#F59E0B",
    tooltip: "Pending registration. WhatsApp is still reviewing this number.",
  },
  REGISTERED: {
    color: "#16A34A",
    tooltip: "",
  },
  REGISTRATION_FAILED: {
    color: "#DC2626",
    tooltip: "Registration failed. Re-submit the number or contact support.",
  },
  WABA_REJECTED: {
    color: "#DC2626",
    tooltip: "WABA rejected. WhatsApp rejected the business account.",
  },
  PHONE_NUMBER_DELETED: {
    color: "#6B7280",
    tooltip: "Phone number deleted from WhatsApp Business.",
  },
  WABA_ERROR: {
    color: "#DC2626",
    tooltip: "WABA error. An error occurred on the WhatsApp Business Account.",
  },
  WABA_DELETED: {
    color: "#6B7280",
    tooltip: "WABA deleted. The business account was removed.",
  },
  WABA_VIOLATION: {
    color: "#DC2626",
    tooltip: "WABA violation. WhatsApp detected a policy violation.",
  },
};

const columns = [
  {
      title: 'Verified Name',
      dataIndex: 'verifiedName',
      key: 'verifiedName',
      width: 70,
      sorter: (a, b) => a.verifiedName.length - b.verifiedName.length,
  },
  {
      title: 'Phone Number',
      dataIndex: 'number',
      key: 'number',
      width: 70,
      sorter: (a, b) => a.number.length - b.number.length,
  },
  {
    title: 'Status',
    dataIndex: 'status',
    key: 'status',
    width: 70,
    sorter: (a, b) => a.status.length - b.status.length,
    render: (_, record) => {
      const status = record.status;
      const registrationStatus = record?.phoneNumberRegistrationStatus;
      const hasRegistrationIssue =
        registrationStatus && registrationStatus !== "REGISTERED";
      const statusMeta = registrationStatusDetails[registrationStatus] ?? {};
      const displayStatus = hasRegistrationIssue ? registrationStatus : status;
      const color = hasRegistrationIssue
        ? statusMeta.color ?? "#6B7280"
        : statusColors[status] ?? "#6B7280";
      const tooltipText = statusMeta.tooltip
        ? `${registrationStatus}: ${statusMeta.tooltip}`
        : `Registration status: ${registrationStatus}`;
      const statusNode = (
        <span
          className={`registration-status ${
            hasRegistrationIssue ? "registration-status--issue" : ""
          }`}
          style={{ color }}
        >
          {displayStatus}
        </span>
      );

      if (hasRegistrationIssue) {
        return (
          <Tooltip title={tooltipText}>
            {statusNode}
          </Tooltip>
        );
      }

      return statusNode;
    }
  },
  {
    title: '',
    dataIndex: 'registrationAction',
    key: 'registrationAction',
    width: 70,
    render: (_, record) => {
      return record?.status === "PENDING_PAYMENT" ? (
        <button className="pay-now-btn" onClick={() =>{ setPaymentModal(true); setPaymentDetails({...paymentDetails, wabaNumber: record.number})}}>
          Pay Now
          <span className="material-symbols-outlined" style={{ fontSize: '18px', marginLeft: '2px' }}>
            arrow_forward
          </span>
        </button>
      ) : "_ _";
    }
  },
];


// const fakePhoneNumbers  = [
//   {id:1, verifiedName: "Test", number: "1234567", phoneNumberRegistrationStatus: "PENDING_PAYMENT"},
//   {id:2, verifiedName: "Test", number: "0987654", phoneNumberRegistrationStatus: "REGISTERED"},
//   {id:3, verifiedName: "Test", number: "4839473", phoneNumberRegistrationStatus: "PENDING_PAYMENT"},
//   {id:4, verifiedName: "Test", number: "9987343", phoneNumberRegistrationStatus: "PENDING_PAYMENT"},
//   {id:5, verifiedName: "Test", number: "3908322", phoneNumberRegistrationStatus: "PENDING_PAYMENT"},
//   {id:6, verifiedName: "Test", number: "1111111", phoneNumberRegistrationStatus: "PENDING_PAYMENT"},
// ]



  return (
    <div>
    <div className='whatsapp-manager'>

      <div className='setup-section'>
      <p className='setup-title'>Go Live: Register your number on WhatsApp for Business API</p>
        {/* <p className='setup-title-p'>Follow the steps below to register your number on WhatsApp for Business API through Lipachat.</p>
           */}
        <ul className='points-to-note'>
          <p>Points to Note: </p>
          <li>If your number is registered on the phone WhatsApp or WhatsApp for business application, de-link it.</li>
          <li>In case of any issues during the process, email us on <span id='support-email'>chat@lipachat.com .</span></li>
        </ul>

    
        <div className='setup-steps-section'>
          <p id='golive-step'>
            <div className='golive-whatsapp-step'>
              <img src={process.env.PUBLIC_URL + "/images/whatsapp-logo.svg"} alt="hero" />
               <p style={{fontWeight:'bold', fontSize:'16px'}}>WhatsApp</p>
             </div>
             <p>Authorize Lipachat to manage your WhatsApp Business Account.</p> 
             
             <button type="button" onClick={() => setPhoneNumberModal(true)} className='facebook-login-btn'>
              Connect<span class="material-symbols-outlined" style={{fontSize:'18px', marginLeft:'10px'}}>arrow_forward</span></button>
          </p>

        </div>
      </div>
    </div>


      {/* /////////////////////enter password modal  */}
      <div className={phoneNumberModal ? 'create-modal-active' : 'create-modal-inactive'} >
      <div className="form-div-section">
        <form id="form-modal" className='view-modal-content'>
          <p className='modal-title'> Enter Phone Number
          <span id='close-button' class="material-symbols-outlined" onClick={() => handleCloseModal(dispatch)}>close</span>
            </p>
          <div className="dialog-inputs">
          <div className="password-form-group">
                <input type='number' name='phoneNumber' className="password-form-control" onChange={(e)=> setPhoneNumber(e.target.value)} 
                placeholder='Ex 254712345678'/>
                <span id="password-error">{formErrors?.phoneNumber}</span>
            </div>
          </div>
          <div className='dialog-footer'>
            
            <div>
            {!action.pending?
                <button type='button' className="submit-btn" onClick={handleRegisterNumber}>Continue</button>:
                <button className="submit-btn-disabled" disabled={true}>{loading()}</button>
            }
            </div>

          </div>
        </form>
        </div>
      </div>

        <div className='connected-numbers-table'>
            <p className='connected-numbers-table-title'>Connected Live Numbers</p>
            <p className='connected-numbers-table-description'>Below are the live numbers currently connected to your account</p>
            <div className='data-table-section'> 
                <Spin spinning={action.pending}>
                    <Table dataSource={registeredNumbers} columns={columns}
                      pagination={false}
                      scroll={{ y: 'calc(38vh - 100px)',}}
                      sticky
                      className="numbers-custom-table"
                    /> 
                  </Spin>   
                </div> 
         </div>


      {/* ///// payment modal  */}
      <div className={paymentModal ? 'create-modal-active' : 'create-modal-inactive'} >
        <div className="form-div-section">

        <form id="form-modal" className='view-modal-content'>
          <p className='modal-title'> Enter Payment Details
          <span id='close-button' class="material-symbols-outlined" onClick={() => handleCloseModal(dispatch)}>close</span>
            </p>
            {/* <p style={{fontSize: '13px', color: '#494F55'}}>Generating a new API Key will result to old key not working</p> */}
          <div className="dialog-inputs">
          <div className="password-form-group">
                <label style={{fontSize: '14px', fontWeight: '600'}}>Phone Number</label>
                <input type='number' name='customerNumber' className="password-form-control" onChange={(e)=>  setPaymentDetails({...paymentDetails, customerPhone: e.target.value})} 
                placeholder='Ex 254712345678' value={paymentDetails?.customerPhone}/>
                <span id="password-error">{formErrors?.customerPhone}</span>
            </div>
          </div>
          <div className="dialog-inputs">
          <div className="password-form-group">
                <label style={{fontSize: '14px', fontWeight: '600'}}>Email Address</label>
                <input type='email' name='customerEmail' className="password-form-control" onChange={(e)=> setPaymentDetails({...paymentDetails, customerEmail: e.target.value})} 
                value={paymentDetails?.customerEmail}/>
                <span id="password-error">{formErrors?.customerEmail}</span>
            </div>
          </div>

          <div className='dialog-footer'>
            <div>
            {!action.pending?
                <button type='button' className="submit-btn" onClick={handleInitiateNumberPayment}>Continue</button>:
                <button className="submit-btn-disabled" disabled={true}>{loading()}</button>
            }
            </div>

          </div>
        </form>

        </div>
      </div>


      {/* /// Confirm pesapal order request  */}
      <div className={confirmOrder ? 'session-modal-active' : 'create-modal-inactive'}>
        <div className="session-modal" >
          <span className="session-title">Notice</span>
          <p className='session-message'>You are now leaving our website You will be redirected to Pesapal website for payment.</p>
          <div className='session-buttons'>

          
            {!action.pending?
                <button type='button' className="session-dismiss-button" onClick={handleConfirmOrder}>Continue</button>:
                <button className="session-dismiss-disabled session-dismiss-button" disabled={true}>{loading()}</button>
            }
            
            <button type='button' className="redirect-hide-button" onClick={() => setConfirmOrder(false)}>Go Back </button>
          </div>
        </div>
      </div>


      <Toaster position="top-right" expand={false} richColors/>

    </div>
  );


}

export default Golive
